/**
 * This file is auto-generated. Do not edit directly.
 * To update, run the generateIconImports.js script.
 */

/**
 * Maps different icon name formats to the actual icon component names
 * This is useful when the API returns icon names in a different format
 * than what is used in the codebase
 * 
 * @param iconName - The icon name from the API
 * @returns The mapped icon component name or the original if no mapping exists
 */
export const mapIconName = (iconName: string): string => {
  // Handle different naming conventions from the API
  
  // Case 1: API returns names without the "Icon" prefix and without "Outline" suffix
  // Example: "Text" -> "IconTextOutline"
  if (!iconName.startsWith('Icon') && !iconName.endsWith('Outline')) {
    return `Icon${iconName}Outline`;
  }
  
  // Case 2: API returns names without the "Icon" prefix but with "Outline" suffix
  // Example: "TextOutline" -> "IconTextOutline"
  if (!iconName.startsWith('Icon') && iconName.endsWith('Outline')) {
    return `Icon${iconName}`;
  }
  
  // Case 3: API returns names with the "Icon" prefix but without "Outline" suffix
  // Example: "IconText" -> "IconTextOutline"
  if (iconName.startsWith('Icon') && !iconName.endsWith('Outline')) {
    return `${iconName}Outline`;
  }
  
  // Case 4: API returns kebab-case names
  // Example: "text-outline" -> "IconTextOutline"
  if (iconName.includes('-')) {
    const parts = iconName.split('-');
    const camelCaseName = parts
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join('');
    
    return `Icon${camelCaseName}Outline`;
  }
  
  // Return the original name if it already has the correct format
  return iconName;
};
